
import React, { useEffect } from 'react';
import { useParams, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LanguageWrapper = () => {
    const { lang } = useParams();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    // Supported languages config
    const supportedLanguages = ['en', 'pt', 'es', 'fr', 'it', 'de'];

    useEffect(() => {
        // Se a rota for acessada sem lang (ex: catch-all fora do /:lang), não faz nada aqui
        if (!lang) return;

        // Se a língua na URL é válida (ex: /pt/...)
        if (supportedLanguages.includes(lang)) {
            // Sincroniza o i18n com a URL
            if (i18n.language !== lang) {
                i18n.changeLanguage(lang);
                localStorage.setItem('selectedLanguage', lang);
            }
            // Atualiza o atributo lang do <html> para SEO
            document.documentElement.lang = lang;
        }
        // Se a língua na URL NÃO é válida (ex: /club-sheet que foi capturado pelo :lang)
        else {
            // Detetamos o idioma preferido
            const currentLang = localStorage.getItem('selectedLanguage') || 'en';

            // Construímos o novo path correto
            // Ex: se estavamos em /club-sheet (lang="club-sheet"), queremos /en/club-sheet
            // O location.pathname é "/club-sheet"

            // Mas cuidado com loops: se o path já tem /en/, não devemos adicionar outro.
            // A verificação supportedLanguages.includes(lang) já previne isso.

            const newPath = `/${currentLang}${location.pathname}`;

            // Redireciona mantendo query params
            navigate(newPath + location.search, { replace: true });
        }
    }, [lang, i18n, navigate, location]);

    // Se estamos numa rota inválida (ex: /club-sheet), não renderizamos o Outlet
    // porque o Outlet esperaria encontrar rotas filhas, e as rotas filhas estão configuradas
    // para estar DEPOIS do :lang.
    if (lang && !supportedLanguages.includes(lang)) {
        return null;
    }

    return <Outlet />;
};

export default LanguageWrapper;
